import '../Assets/Styles/home.css';
import '../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';


import { Panel } from 'primereact/panel';
import Box from '@mui/material/Box';

import { useLocation } from 'react-router-dom';
import dashRoutes from '../routes'; // default import

import moment from "moment";
import iconComingSoon from '../Assets/Images/iconComingSoon.png';

// Load Actions
import * as AppActions from '../Store/Actions/App'

import HeaderView from '../Components/Layout/Header';

// Load Componentes
import SideMenu from '../Components/SideMenu';



// export default function Reservation() {
const ComingSoon = (props) => {
  
// Set var from props
const {
  setDialog,
  dialog
} = props;


const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });


const location = useLocation();
const currentPath = location.pathname;

// Procura pelo nome da rota atual
const currentRoute = dashRoutes.find(route => {
  // Rotas com parâmetros (ex: /noticias/:slugId) precisam de tratamento especial.
  // Mas neste caso (ComingSoon), seus paths são exatos.
  return route.path === currentPath;
});

const routeName = currentRoute?.name || "Conteúdo indisponível";
 
  return (
  <>
  <div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
    <div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		

      <HeaderView isOnAdmin={true} />

      <div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start",marginTop:"6rem"}}>
            
        <div style={{flex:1,display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:isMobile ? "10px" : "40px",marginTop:"40px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
        
            {/* Admin Side Menu */}
            <SideMenu state="open" />
            
            {/* Admin Content */}
            <div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            
              <div style={{height:isMobile ? "" : "64px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
              
                <div style={{textAlign:"left",flex:2,color: '#2E0249', fontFamily: 'Titillium Web', fontSize:isMobile ? '32px' : '36px', fontStyle: 'normal', fontWeight: 600, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>{routeName}</div>
              
              </div>
              
              
              <div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
              
                <div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>
      
                  <Box
                    sx={{
                    width: isMobile ? "100%" : "80%",
                    padding:"30px",
                    minHeight:"40vh"
                    }}
                  >
                    <div className="registerModalIntro"> <i>O conteúdo que está tentando acessar está indisponível. <br /> Retorne em alguns dias.</i></div>	

                    <Divider />

                    <div style={{width:"100%",height:"40vh",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",gap:"20px",marginTop:"50px"}}>
                        <div><img src={iconComingSoon} style={{width:"100px",height:"auto"}} /></div>
                        <div style={{fontSize:"2rem",fontFamily:"Graphie"}}>Conteúdo ainda indisponível</div>
                    </div>

    
                </Box>
                
                  
                </div>							
              
              </div>
            
            </div>
            
        </div>
      
      </div> 
    </div>
    
        
    </div>
  
  </>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ComingSoon);	


